import Vue from 'vue';
import {
  Swipe,
  SwipeItem,
  IndexBar,
  IndexAnchor,
  Loading,
  Tab,
  Tabs,
  Search,
  List,
  Toast,
  Popup,
  Icon,
  Button,
  Dialog,
  Field,
  Cell,
  CellGroup,
  Checkbox,
  CheckboxGroup,
  DatetimePicker,
  NumberKeyboard,
  Progress,
  Calendar,
  Image as VanImage,
  Overlay,
  NavBar,
} from "vant";

Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(IndexBar);
Vue.use(IndexAnchor);
Vue.use(Loading);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Search);
Vue.use(List);
Vue.use(Icon);
Vue.use(Button);
Vue.use(Dialog);
Vue.use(Field);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(CheckboxGroup);
Vue.use(Checkbox);
Vue.use(NumberKeyboard);
Vue.use(Toast);
Vue.use(Popup);
Vue.use(DatetimePicker);
Vue.use(Progress);
Vue.use(Calendar);
Vue.use(VanImage);
Vue.use(Overlay);
Vue.use(NavBar);